import { useEffect, useState } from 'react';
import { MapPinOff, Loader2, RefreshCw } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';

const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

export function GeoErrorModal({ geo, onRetry }) {
  const { t: tr } = useTranslation();
  const t = (k) => tr(`startStop.${k}`);
  const [hidden, setHidden] = useState(false);
  useEffect(() => { if (geo.status === 'error') setHidden(false); }, [geo.status, geo.error]);
  if (geo.status === 'ok' || hidden || (geo.status !== 'error' && geo.status !== 'loading')) return null;
  if (geo.status === 'loading' && !geo.retried) return null;
  const denied = !!geo.denied;
  const loading = geo.status === 'loading';
  return (
    <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-testid="ss-geo-modal">
      <div className="w-full max-w-sm rounded-3xl bg-white dark:bg-slate-900 p-6 space-y-4 shadow-2xl animate-in slide-in-from-bottom-4 duration-200">
        <div className="mx-auto h-16 w-16 rounded-full bg-rose-100 flex items-center justify-center"><MapPinOff className="h-8 w-8 text-rose-600" /></div>
        <div className="text-center space-y-1">
          <h3 className="text-xl font-black">{t('geoModalTitle')}</h3>
          <p className="text-sm text-slate-600 dark:text-slate-300" data-testid="ss-geo-modal-msg">{geo.error || t('geoWaiting')}</p>
        </div>
        <ol className="rounded-2xl bg-slate-50 dark:bg-slate-800 p-3 space-y-1.5 text-sm">
          {[].concat(t(denied ? (isIOS() ? 'stepsDeniedIos' : 'stepsDeniedAndroid') : 'stepsOther')).map((s, i) => (
            <li key={s} className="flex gap-2"><span className="h-5 w-5 shrink-0 rounded-full bg-slate-900 text-white text-[11px] font-bold flex items-center justify-center">{i + 1}</span>{s}</li>
          ))}
        </ol>
        <p className="text-xs text-center text-slate-500">{t('geoRequired')}</p>
        <button type="button" onClick={onRetry} disabled={loading} data-testid="ss-geo-modal-retry"
          className="w-full h-14 rounded-2xl bg-rose-600 hover:bg-rose-700 text-white text-lg font-black flex items-center justify-center gap-2 disabled:opacity-70">
          {loading ? <><Loader2 className="h-5 w-5 animate-spin" />{t('gettingLocation')}</> : <><RefreshCw className="h-5 w-5" />{t('retry')}</>}
        </button>
        <button type="button" onClick={() => setHidden(true)} className="w-full text-sm text-slate-500 py-1" data-testid="ss-geo-modal-close">{t('close')}</button>
      </div>
    </div>
  );
}
